import { render, staticRenderFns } from "./PaymentSupplierOrderCreateUpdate.vue?vue&type=template&id=06bd3562&"
import script from "./PaymentSupplierOrderCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PaymentSupplierOrderCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports